import ApiService from './ApiService';

class TraderService {
  async findTrader(payload = {}) {
    try {
      const response = await ApiService.call('/secured/get_trader', 'POST', payload);
      let data = response;

      return {
        traderId: data.traderId,
        name: data.name,
        nrcNo: data.nrcNo,
        clientType: data.clientType,
        primaryEmail: data.primaryEmail,
        currentHoldingList: data.currentHoldingList,
        success: true,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }
}
export default new TraderService();
